import { TableColumn } from "../../types";

export function TagValueColumn<TData extends { tags?: Record<string, any> }>(tagKey: string): TableColumn<TData> {
  return {
    id: `tag:${tagKey}`,
    label: tagKey,
    accessorFn: (row) => row.tags?.[tagKey] ?? "",
    cell: (p) => {
      const value = p.getValue();
      if (value === "" || value === undefined || value === null) {
        return <span style={{ color: "var(--color-label)" }}>{"\u2014"}</span>;
      }
      return <span>{String(value)}</span>;
    },
    enableSort: false,
    enableFilter: false,
    enableResize: true,
    enableHide: true,
    hiddenByDefault: true,
    size: 150,
  };
}
